import '../../../diagnosticReporting/DiagnosticStyles.css';
import React, {useState, useContext, useEffect} from 'react';
import {Form, Select, Row, Col, Divider, Checkbox, Table, Tooltip} from 'antd';
import {AGGREGATE_LEVELS, FB_MESSAGES, GRID_ENUMS, GridStyle} from "../../../diagnosticReporting/Styles";
import axios from "@common/axios";
import StudentTestResultDialog from "../../../diagnosticReporting/StudentTestResultDialog";
import CircularLoader from "@common/CircularLoader";
import {BrandContext} from "@context/BrandContext";
import {UserContext} from "@context/UserContext";
import GroupByAggregateView from "../../../diagnosticReporting/GroupByAggregateView";
import HelpIcon from "@mui/icons-material/Help";
import ClassQuestionViewDiagnostic from "../../../diagnosticReporting/ClassQuestionViewDiagnostic";
import Button from "@common/Button";
import TableAntD from "@common/TableAntD";
import TableFilterControlsForm from "@common/TableFilterControlsForm";
import TableFilterControlsSection from "@common/TableFilterControlsSection";
import ClassSelect from "@common/ClassSelect";

const { Option } = Select;
const STANDARD_REPORTS = {
        CLASS_QUESTION_VIEW: {val: 1, description: 'Results by question'},
        GROUP_BY_VIEW: {val: 2, description: 'Results by skills (exams only)'},
    },
    AGGREGATE_VIEW_TOOLTIP = (<div><p>This will allow you to see student performance at various textbook/curriculum levels.</p>
        {/*<p>Use the column toggle buttons to collapse the view.</p>*/}
    </div>);

const TestExamReports = (props) => {

    const brandConfig = useContext(BrandContext),
        {user, setUser, menuPosition} = useContext(UserContext),
        [isLoading, setLoading] = useState(false),
        [isTableLoading, setTableLoading] = useState(false),
        [feedbackMessage, setFeedbackMessage] = useState(undefined),
        [warningFeedbackMessage, setWarningFeedbackMessage] = useState(undefined),
        [selectedTestTypes,setSelectedTestTypes] = useState([]),
        [students, setStudents] = useState([]),
        [studentIds, setStudentIds] = useState([]),
        [initialStudentIds, setInitialStudentIds] = useState([]),
        [className, setClassName] = useState(user.classId ? user.classes[user.classId] : null),
        [reportForm] = Form.useForm(),
        classId =  Form.useWatch('classId', reportForm),
        [selectedTestTypeVal, setSelectedTestTypeVal] = useState(STANDARD_REPORTS.CLASS_QUESTION_VIEW.val),
        [selectedTestTypeTempVal, setSelectedTestTypeTempVal] = useState(STANDARD_REPORTS.CLASS_QUESTION_VIEW.val),
        [selectedAggregateLevel, setSelectedAggregateLevel] = useState(AGGREGATE_LEVELS.CONCEPT),
        [reportTitle, setReportTitle] = useState(''),
        [testAssignmentData, setTestAssignmentData] = useState([]),
        [testAssignmentResultsData, setTestAssignmentResultsData] = useState(undefined),
        [studentTestAssignmentsMap, setStudentTestAssignmentsMap] = useState({}),
        [initialTestAssignmentData, setInitialTestAssignmentData] = useState([]),
        [studentColOrder, setStudentColOrder] = useState(GRID_ENUMS.NAME_ASC),
        [classForm] = Form.useForm(),
        [classFilterForm] = Form.useForm(),
        [testAssignments, setTestAssignments] = useState([]),
        [testId, setTestId] = useState(null),
        [testAssignmentId, setTestAssignmentId] = useState(null),
        [tempTestAssignmentId, setTempTestAssignmentId] = useState(null),
        [testName, setTestName] = useState(''),
        [headerHeightOffset, setHeaderHeightOffset] = useState(0),
        [selectedDifficultyIds, setSelectedDifficultyIds] = useState([]),
        [studentId, setStudentId] = useState(),
        [triggerStandardGenerate, setTriggerStandardGenerate] = useState(null),
        [selectedRowKeys, setSelectedRowKeys] = useState([]),
        [lastRecordKey, setLastRecordKey] = useState(-1),
        [studentTestResultDialogOpen, setStudentTestResultDialogOpen] = useState(false),
        [questionCount, setQuestionCount] = useState();

    const handleCloseStudentTestsDialog = () => {
        setStudentTestResultDialogOpen(false);
        setStudentId(null);
    }

    const openStudentTestsDialog = (studentId) => {
        if (studentId == null) {
            return;
        }

        setStudentId(studentId);
        setStudentTestResultDialogOpen(true);
    }

    const handleClassSelect = (classId) => {
        setClassName(user.classes[classId]);
        setSelectedRowKeys([]);
        setTestId(null);
        setTestAssignmentId(null);
        setTestAssignmentResultsData(undefined);
    }

    useEffect(()=>{
        if(classId){
            axios.get('/web/ui/sc/studentsInClass',{params: {classId: classId}})
                .then(response => {
                    if(response.data){
                        const students = response.data;
                        setStudents(students);
                        const ids = [];
                        students.map(student=>{
                            ids.push(student.userId);
                        });
                        setStudentIds(ids);
                        setInitialStudentIds(ids);
                        reportForm.setFieldsValue({['studentIds']:ids});
                        if(students.length === 0){
                            setWarningFeedbackMessage(undefined);
                        }
                    }
                }).catch(error =>{
                console.error('Error loading students. ',error);
            });
        }else{
            showCascadingFeedbackMessage();
        }
    },[classId]);

    useEffect(() => {
        showCascadingFeedbackMessage();
    }, [students, studentIds]);

    const clearStudentSelect = ()=>{
        reportForm.setFieldsValue({['studentIds']:[]});
        setStudentIds([]);
    }

    const handleClassClear = ()=>{
        clearStudentSelect();
        // setClassId(undefined);
        reportForm.setFieldValue('classId', undefined);
        setStudents([]);
        setInitialStudentIds([]);
        setWarningFeedbackMessage(undefined);
    }

    const handleStudentChange = value=>{
        setStudentIds(value);
    }

    const handleSelectAllChange = event =>{
        if(event.target.checked){
            setStudentIds(initialStudentIds);
            reportForm.setFieldsValue({['studentIds']:initialStudentIds});
        }else{
            clearStudentSelect();
        }
    }

    const handleDifficultyChange = value =>{
        // setLoading(true);
        setSelectedDifficultyIds(value);
    }

    const handleStudentColOrderByChange = value =>{
        // setLoading(true);
        setStudentColOrder(value);
    }

    const handleReportChange = value =>{
        setSelectedTestTypeTempVal(value);
    }

    useEffect(()=>{
        if(initialTestAssignmentData.length > 0){
            setTestAssignmentData(filterTestsAndExams([...initialTestAssignmentData]));
        }
    },[selectedTestTypeTempVal]);

    const filterTestsAndExams = (data) => {
        if (STANDARD_REPORTS.GROUP_BY_VIEW.val === selectedTestTypeTempVal) {
            data = data.filter((item) => item.isExam);
        }
        setSelectedRowKeys([]);
        setTestId(null);
        setTestAssignmentId(null);
        setTestAssignmentResultsData(undefined);
        return data;
    }

    const generateStandardReport = ()=> {
        if (!classId) {
            showCascadingFeedbackMessage();
            setLoading(false);
            return;
        }
        setSelectedTestTypeVal(selectedTestTypeTempVal);
        if(testAssignmentId && tempTestAssignmentId && testAssignmentId === tempTestAssignmentId){
            setTriggerStandardGenerate(new Date().getTime());
        }else{
            setTestAssignmentId(tempTestAssignmentId);
        }
    }

    useEffect(()=>{
        if(testAssignmentId !== null){
            setReportTitle(STANDARD_REPORTS.CLASS_QUESTION_VIEW.description+ ' &#8212; '+testName);
            setTriggerStandardGenerate(new Date().getTime());
        }
    },[testAssignmentId])

    const showCascadingFeedbackMessage = ()=>{
        let messageShown = false;
        if(!classId){
            setFeedbackMessage(FB_MESSAGES.SELECT_CLASS_TEST_MESSAGE);
            messageShown = true;
        }else if (students.length === 0) {
            setFeedbackMessage(FB_MESSAGES.NO_STUDENTS_IN_CLASS);
            messageShown = true;
        } else if (studentIds.length === 0) {
            setFeedbackMessage(FB_MESSAGES.SELECT_STUDENT_TEST_MESSAGE);
            messageShown = true;
        } else if (testAssignments.length === 0) {
            setFeedbackMessage(FB_MESSAGES.STANDARD_TEST_NO_ASSIGNMENTS_MESSAGE);
            messageShown = true;
        } else if (testId === null) {
            setFeedbackMessage(FB_MESSAGES.SELECT_STANDARD_TEST_MESSAGE);
            messageShown = true;
        } else if (testAssignmentResultsData !== undefined && !testAssignmentResultsData.hasQuestionResults && testId !== null) {
            setFeedbackMessage(FB_MESSAGES.NO_STUDENT_RESULTS_DATA_NO_TEST);
            messageShown = true;
        } else {
            setFeedbackMessage(undefined);
        }

        return messageShown;
    }

    useEffect(()=>{
        if(classId) {
            setTableLoading(true);
            axios.get('/web/ui/test/teacherAssignmentsStandard/' + classId)
                .then(response => {
                    if (response.data) {
                        setTestAssignments(response.data);
                    }
                }).catch(e => {
                console.error('Error loading teacher test assignments: ', e);
            });
        }else{
            handleClassClear();
            setTestAssignments([])
        }
        showCascadingFeedbackMessage();
    },[classId])

    useEffect(()=>{
        if(testAssignments.length > 0){
            const standardData = [];
            testAssignments.forEach( tA =>{
                standardData.push({
                    name: tA.testName,
                    key: tA.testAssignmentId,
                    testId: tA.testId,
                    assignedBy: tA.assignedBy,
                    assignedDate: user.dateFormat.format(new Date(tA.assignedDate)),
                    startDate: user.dateFormat.format(new Date(tA.startDate)),
                    endDate: tA.endDate ? user.dateFormat.format(new Date(tA.endDate)) : GRID_ENUMS.NOT_AVAILABLE,
                    expiry: tA.expired ? 'expired' : tA.timeToExpiry,
                    isExam: tA.exam
                });
            });

            for(let i = 0; i < standardData.length; i++){
                let dataRow = standardData[i];
                if(dataRow.testId){
                    axios.get('/web/ui/test/test',{params:{ testId: dataRow.testId }}).then(response =>{
                        if(response.data){
                            dataRow.questions = response.data.questionCount;
                            dataRow.createdBy = response.data.ownedBy;
                        }
                        if(i === standardData.length-1){
                            setTestAssignmentData(filterTestsAndExams(standardData));
                            setInitialTestAssignmentData(standardData);
                            setTableLoading(false);
                        }
                    }).catch(error =>{
                        console.error('Error retrieving test: ', error);
                    });
                }
            }
        }else{
            setTestAssignmentData([]);
            setInitialTestAssignmentData([]);
            setTableLoading(false);
        }
    },[testAssignments]);

    useEffect(()=>{
        if(testAssignmentData.length > 0){
            testAssignmentData.forEach( rowData =>{
                rowData.enabled = students.length > 0;
            });
        }
    },[testAssignmentData]);

    useEffect(()=>{
        showCascadingFeedbackMessage();
    },[selectedRowKeys]);


    /* sticky header */
    const fixedTableHeaderScroll = (e,tableView) =>{
        const testExamReportsEl = document.getElementById('teacherTests');

        if(testExamReportsEl == undefined){
            return;
        }

        const root = testExamReportsEl.getElementsByClassName('ag-root')[0];

        if (root === undefined) {
            return;
        }

        const tablePosition = tableView.getBoundingClientRect().top+window.scrollY+GridStyle.VERTICAL_HEADER_OFFSET,
            parentWidth = root.clientWidth,
            leftHeaderWidth = testExamReportsEl.getElementsByClassName('ag-pinned-left-header')[0].clientWidth,
            viewPort = testExamReportsEl.getElementsByClassName('ag-header-viewport')[0],
            headerElem = testExamReportsEl.getElementsByClassName('ag-header')[0],
            rightHeaderElem = testExamReportsEl.getElementsByClassName('ag-header-row-column')[0],
            scrollMask = testExamReportsEl.getElementsByClassName('grid-fixed-mask')[0];

        if(Math.round(tablePosition) < 0){
            // header fixed
            setHeaderHeightOffset(GridStyle.VERTICAL_HEADER_HEIGHT);
            headerElem.classList.add("fixed-ag-header");
            rightHeaderElem.classList.add("fixed-ag-header-right");
            scrollMask.classList.add("show");
        }else{
            // header unset
            setHeaderHeightOffset(0);
            headerElem.classList.remove("fixed-ag-header");
            rightHeaderElem.classList.remove("fixed-ag-header-right");
            scrollMask.classList.remove("show");
        }
        viewPort.style.width = (parentWidth-leftHeaderWidth)+"px";
        headerElem.style.width = (parentWidth)+"px";
        scrollMask.style.width = (parentWidth + 2)+"px";
    }

    useEffect(() => {
        const tableView = document.getElementById('graphView');

        document.getElementById('content').addEventListener("scroll",e=>{
            fixedTableHeaderScroll(e,tableView);
        });
        window.addEventListener('resize', e=>{
            fixedTableHeaderScroll(e,tableView);
        });
        return () => {
            document.getElementById('content').removeEventListener("scroll",fixedTableHeaderScroll);
            window.removeEventListener("scroll",fixedTableHeaderScroll);
            // window.removeEventListener('toggleNav',fixedTableHeaderScroll);
        }

    }, []);

    useEffect(()=>{
        const tableView = document.getElementById('graphView');
        if(tableView){
            for(let i = 1; i <= 50; i++){
                setTimeout(()=>{
                    fixedTableHeaderScroll(null,tableView);
                },i*10);
            }
        }
    },[menuPosition.rightMenuClosed, menuPosition.leftMenuClosed]);

    /* sticky header end*/

    const standardTestAssignmentColumns = [
        {
            title: 'Name',
            dataIndex: 'name',
            width: 200,
            ellipsis: true
        },
        {
            title: 'Questions',
            dataIndex: 'questions',
            width: 90,
            align:'center'
        },
        {
            title: 'Created by',
            dataIndex: 'createdBy',
            ellipsis: true,
            width: 120
        },
        {
            title: 'Assigned by',
            dataIndex: 'assignedBy',
            ellipsis: true,
            width: 120
        },
        {
            title: 'Assigned date',
            dataIndex: 'assignedDate',
            width: 110
        },
        {
            title: 'Start date',
            dataIndex: 'startDate',
            width: 95
        },
        {
            title: 'End date',
            dataIndex: 'endDate',
            width: 95
        },
        {
            title: 'Expiry',
            dataIndex: 'expiry',
            ellipsis: true,
            width:95
        }
        // {
        //     title: 'Recipients',
        //     dataIndex: 'students'
        // },
    ];

    useEffect(()=>{
        if(testAssignmentId == null){
            return;
        }

        let hasQuestionResults = false;
        setLoading(true);
        axios.get('/web/ui/test/loadTestAssignmentReportResults',{params: {testAssignmentId: testAssignmentId, classId: classId}})
            .then(response => {
                if(!response.data){
                    return;
                }
                let studentAssignmentIdsMap = {};
                for (const [studentKey, testMapValue] of Object.entries(response.data.studentTestAssignmentMap)) {
                    if (studentAssignmentIdsMap[studentKey]) {
                        for (const [testKey, assignmentValue] of Object.entries(studentAssignmentIdsMap[studentKey])) {
                            if (testMapValue.hasOwnProperty(testKey)) {
                                testMapValue[testKey] = [...testMapValue[testKey], ...assignmentValue];
                            }
                        }

                        studentAssignmentIdsMap[studentKey] = {...studentAssignmentIdsMap[studentKey], ...testMapValue};
                    } else {
                        studentAssignmentIdsMap[studentKey] = testMapValue;
                    }
                }

                hasQuestionResults = response.data.hasQuestionResults;
                setStudentTestAssignmentsMap(studentAssignmentIdsMap);
                setQuestionCount(response.data.questionCount);
                setTestAssignmentResultsData(response.data);
                setLoading(false);

                if (hasQuestionResults) {
                    setFeedbackMessage(undefined);
                } else {
                    setFeedbackMessage(FB_MESSAGES.NO_STUDENT_RESULTS_DATA_NO_TEST);
                }
            }).catch(error => {
                console.error('Error loading test assignment results: ', error);
                setLoading(false);
                setTestAssignmentResultsData(undefined);
            });
    },[triggerStandardGenerate]);

    const handleAggregateLevelChange = value =>{
        if(classId && testAssignmentId !== null){
            setLoading(true);
        }else{
            showCascadingFeedbackMessage();
        }
        setSelectedAggregateLevel(value);
    }

    const rowSelection = {
        selectedRowKeys,
        type:'radio',
        onChange: (selectedRowKeys, selectedRows) => {
            const record = selectedRows[0];
            onRowClick(record);
        }
    };

    const onRowClick = (record)=>{
        setTestId(record.testId);
        setTempTestAssignmentId(record.key);
        setTestName(record.name);
        if(record.key === lastRecordKey && selectedRowKeys.length > 0){
            // setSelectedRowKeys([]);
            // setStandardTestId(null);
            // setStandardTestAssignmentId(null);
        }else{
            setSelectedRowKeys([record.key]);
        }
        setLastRecordKey(record.key);
    }

    useEffect(()=>{
        showCascadingFeedbackMessage();
    },[testId]);

    return (
        <div id={"testExamReports"}>
            <div className={'grid-fixed-mask'}>
                <div className={'top-mask'}></div>
                <div className={'border-mask'}></div>
            </div>

            <div className={"reportsFormWrapper"}>
                <TableFilterControlsForm
                    name="contentSearchForm"
                    form={reportForm}
                    autoComplete="off"
                    initialValues={{classId:user.classId, studentIds:initialStudentIds, diagnosticTests:[]}}
                    // onFinish={handleSearch}
                >
                    <TableFilterControlsSection showDivider={false}>
                        <Form.Item
                            label="Class"
                            name="classId">
                            <ClassSelect
                                classes={user.classes}
                                width={'100%'}
                                onSelect={handleClassSelect}
                                onClear={handleClassClear}
                                getPopupContainer={trigger => trigger.parentElement}
                                virtual={false}
                                autoClearSearchValue={true}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Student"
                            name="studentIds"
                        >
                            <Select virtual={false} showSearch={false} popupRender={menu => (
                                <div>
                                    {menu}
                                    <Divider style={{margin: '0 0 4px 0'}}/>
                                    <div style={{padding: '4px'}}>
                                        <Checkbox tabIndex={0} disabled={initialStudentIds.length === 0} value={studentIds}
                                                  defaultChecked={true}
                                                  checked={studentIds.length === initialStudentIds.length}
                                                  onChange={handleSelectAllChange}>Select all students</Checkbox>
                                    </div>
                                </div>
                            )} allowClear autoClearSearchValue={true}
                                // onSelect={handleStudentSelect} onDeselect={handleStudentDeselect}
                                    onChange={handleStudentChange}
                                // onClear={handleStudentClear}
                                    mode="multiple" maxTagCount="responsive"
                                    getPopupContainer={trigger => trigger.parentElement}>
                                {students.map((student) => {
                                    return <Option key={student.userId}
                                                   value={student.userId}>{student.lastName + ', ' + student.firstName}</Option>;
                                })}
                            </Select>
                        </Form.Item>
                    </TableFilterControlsSection>
                </TableFilterControlsForm>
                <Form
                    name="classDiagnostic"
                    form={classForm}
                    initialValues={{reportViewVal:STANDARD_REPORTS.CLASS_QUESTION_VIEW.val}}
                    autoComplete="off"
                    labelCol={{ span: 3 }}
                    // wrapperCol={{ span: 12 }}
                >
                    <Row align={"bottom"}>
                            <Col span={16} >
                                <h5>Test assignment select</h5>
                                <Form.Item style={{marginLeft:0}}
                                           label="Report type"
                                           name="reportViewVal">
                                    <Select onChange={handleReportChange}
                                            getPopupContainer={trigger => trigger.parentElement}>
                                        <Option key={STANDARD_REPORTS.CLASS_QUESTION_VIEW.val}
                                                value={STANDARD_REPORTS.CLASS_QUESTION_VIEW.val}>{STANDARD_REPORTS.CLASS_QUESTION_VIEW.description}</Option>
                                        <Option key={STANDARD_REPORTS.GROUP_BY_VIEW.val}
                                                value={STANDARD_REPORTS.GROUP_BY_VIEW.val}>{STANDARD_REPORTS.GROUP_BY_VIEW.description}</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <div style={{marginTop:'8px', position: 'relative', width: '100%'}}>
                                <TableAntD
                                    dynamicWidth={true}
                                    className={'testSelectionTable'}
                                    size={'small'}
                                    // rowHeight={'80px'}
                                    columnData={standardTestAssignmentColumns}
                                    dataSource={testAssignmentData}
                                    rowSelection={rowSelection}
                                    rowClassName={record => {
                                        if(record.enabled !== undefined && !record.enabled){
                                            return 'table-report-disabled-row';
                                        }else{
                                            return '';
                                        }
                                    }}
                                    loading={isTableLoading}
                                    pagination={{hideOnSinglePage:true}}
                                    scroll={{ y: 240 }}
                                    onRow={(record) => ({
                                        onClick: () => {
                                            // console.log('onRowClick record: ',record);
                                            //select and de-select row
                                            onRowClick(record);
                                        }
                                    })}
                                />
                            </div>
                        <Col>
                            <Form.Item name="generateStandard">
                                <Button size={'medium'} disabled={(selectedRowKeys.length === 0 || students.length === 0 || isLoading)} onClick={generateStandardReport}>Generate</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <Form className="inlineForm ignoreInlineForm"
                      name="classDiagnosticFilterForm"
                      form={classFilterForm}
                      layout="vertical"
                      size="small"
                      initialValues={{ columnOrderBy: GRID_ENUMS.NAME_ASC, aggregateGroupBy: AGGREGATE_LEVELS.CONCEPT }}
                      autoComplete="off"
                      style={{
                          borderBottom:'1px solid lightgrey'
                      }}
                >
                    <Row>
                        <Col span={12}>
                            <h5>Filter</h5>
                            <Form.Item
                                label="Difficulty"
                                name="difficulty"
                                style={{width: '95%'}}
                            >
                                <Select showSearch={false} allowClear mode="multiple"
                                        onChange={handleDifficultyChange}
                                        getPopupContainer={trigger => trigger.parentElement}>
                                    {brandConfig.testLevels.map((level) => {
                                        return <Option key={level} value={level}>{level}</Option>
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        {((selectedTestTypeVal === STANDARD_REPORTS.CLASS_QUESTION_VIEW.val)) &&
                            <Col span={12}>
                                <h5>Order by</h5>
                                <Form.Item
                                    label="Student"
                                    name="columnOrderBy"
                                    style={{width: '95%'}}
                                >
                                    <Select onChange={handleStudentColOrderByChange}
                                            getPopupContainer={trigger => trigger.parentElement}>
                                        <Option key={GRID_ENUMS.NAME_ASC} value={GRID_ENUMS.NAME_ASC}>first name
                                            ascending</Option>
                                        <Option key={GRID_ENUMS.NAME_DESC} value={GRID_ENUMS.NAME_DESC}>first name
                                            descending</Option>
                                        <Option key={GRID_ENUMS.LOWEST} value={GRID_ENUMS.LOWEST}>lowest
                                            performance</Option>
                                        <Option key={GRID_ENUMS.HIGHEST} value={GRID_ENUMS.HIGHEST}>highest
                                            performance</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        }
                        {(selectedTestTypeVal === STANDARD_REPORTS.GROUP_BY_VIEW.val
                            // || selectedTestTypeVal === REPORTS.CLASS_QUESTION_VIEW.val
                        ) &&
                        <Col span={12} id="aggregateFields">
                            <h5>Aggregate view<Tooltip title={AGGREGATE_VIEW_TOOLTIP}
                                // placement="bottom"
                                                       arrowPointAtCenter>
                                <HelpIcon style={{
                                    verticalAlign: 'middle',
                                    marginLeft: '4px',
                                    marginTop: '-2px',
                                    width: '16px',
                                    height: '16px'
                                }}/>
                            </Tooltip></h5>
                            {/*<Form.Item label="Toggle">*/}
                            {/*    <Switch*/}
                            {/*        style={{marginLeft:'8px'}}*/}
                            {/*        onChange={toggleAggregate}*/}
                            {/*        color="primary"*/}
                            {/*    />*/}
                            {/*</Form.Item>*/}
                            {/*<Form.Item name="contentType" label="Course type"*/}
                            {/*    // tooltip={{title:'Filter by course type'}}*/}
                            {/*>*/}
                            {/*    <Radio.Group onChange={handleContentTypeChange} disabled={aggregateDisabled}>*/}
                            {/*        <Radio.Button value={GRID_ENUMS.TEXT}>Text</Radio.Button>*/}
                            {/*        <Radio.Button disabled={curriculumDisabled} value={GRID_ENUMS.EXAM}>Curriculum</Radio.Button>*/}
                            {/*    </Radio.Group>*/}
                            {/*</Form.Item>*/}
                            <Form.Item
                                label="Group by"
                                name="aggregateGroupBy"
                                style={{marginLeft:'8px'}}
                            >
                                <Select onChange={handleAggregateLevelChange}
                                    // disabled={aggregateDisabled}
                                        style={{minWidth: '150px'}}
                                        getPopupContainer={trigger => trigger.parentElement}>
                                    {/*<Option key={AGGREGATE_LEVELS.SKILL}*/}
                                    {/*        value={AGGREGATE_LEVELS.SKILL}>Skill</Option>*/}
                                    <Option key={AGGREGATE_LEVELS.CONCEPT}
                                            value={AGGREGATE_LEVELS.CONCEPT}>Sub-topic</Option>
                                    <Option key={AGGREGATE_LEVELS.TOPIC}
                                            value={AGGREGATE_LEVELS.TOPIC}>Area of Study</Option>
                                    <Option key={AGGREGATE_LEVELS.SYLLABUS}
                                            value={AGGREGATE_LEVELS.SYLLABUS}>Unit</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        }
                    </Row>
                </Form>
            </div>
            <div id="graphView">
                <CircularLoader displayInElement={true} pageCentered={true} visible={isLoading} />
                {!isLoading &&
                    <>
                        {feedbackMessage !== undefined &&
                            <p className={'ch-dashboard-warning-text'}>{feedbackMessage}</p>}
                        {studentIds.length > 0 && testAssignmentResultsData != undefined && testAssignmentResultsData.hasQuestionResults &&
                            <>
                                <h3 dangerouslySetInnerHTML={{__html: reportTitle}}/>
                                {warningFeedbackMessage !== undefined &&
                                    <p className={'ch-dashboard-warning-text'}>{warningFeedbackMessage}</p>}
                                <div>
                                    {selectedTestTypeVal === STANDARD_REPORTS.CLASS_QUESTION_VIEW.val &&
                                        <ClassQuestionViewDiagnostic
                                            isDiagnostic={false}
                                            testAssignmentsData={[testAssignmentResultsData]}
                                            studentTestAssignmentsMap={studentTestAssignmentsMap}
                                            questionCount={questionCount}
                                            students={students}
                                            studentIds={studentIds}
                                            classId={classId}
                                            className={className}
                                            studentColOrder={studentColOrder}
                                            selectedDifficultyIds={selectedDifficultyIds}
                                            selectedTestIds={[testId]}
                                            isLoading={isLoading}
                                            setLoading={setLoading}
                                            feedbackMessage={feedbackMessage}
                                            headerHeightOffset={headerHeightOffset}
                                            openDialogCallback={openStudentTestsDialog}
                                            triggerGenerate={triggerStandardGenerate}
                                        />
                                    }
                                    {selectedTestTypeVal === STANDARD_REPORTS.GROUP_BY_VIEW.val &&
                                        <GroupByAggregateView
                                            isDiagnostic={false}
                                            testAssignmentsData={[testAssignmentResultsData]}
                                            students={students}
                                            studentIds={studentIds}
                                            classId={classId}
                                            className={className}
                                            studentColOrder={studentColOrder}
                                            selectedAggregateLevel={selectedAggregateLevel}
                                            selectedDifficultyIds={selectedDifficultyIds}
                                            selectedTestIds={[testId]}
                                            contentType={GRID_ENUMS.TEXT}
                                            testAssignmentType={GRID_ENUMS.EXAM}
                                            isLoading={isLoading}
                                            setLoading={setLoading}
                                            selectedTestTypes={selectedTestTypes}
                                            headerHeightOffset={headerHeightOffset}
                                            openDialogCallback={openStudentTestsDialog}
                                            triggerGenerate={triggerStandardGenerate}
                                        />
                                    }
                                </div>
                            </>
                        }
                    </>
                }
                <StudentTestResultDialog open={studentTestResultDialogOpen} testAssignmentId={testAssignmentId} studentId={studentId} handleClose={handleCloseStudentTestsDialog} />
            </div>
        </div>
    );
}
export default TestExamReports;
